import React, { useEffect, useState } from "react";
import swal from 'sweetalert';
import { Link } from "react-router-dom";
import { useForm } from "../../hooks/useForm";
import { getAllCertificatesStudentsService } from "../../selectors/getCertificates";
import { permisos } from "../../helper/permissions";

export const ListCertificatesStudents = () => {

  const seccion = 'Cursos'
  permisos(seccion, 'listar', 'alerta')
  const hasListarPermission = permisos(seccion, 'listar')
  const hasEditarPermission = permisos(seccion, 'editar')
  const hasVerPermission = permisos(seccion, 'ver')
  const hasListarEstudaintesPermission = permisos(seccion, 'estudiantes')


  if (localStorage.getItem('certificteById')) {
    localStorage.removeItem('certificteById')
  }
  const [certificates, setCertificates] = useState([]);
  const [page, setPages] = useState({});
  const [formValues, handleInputChange] = useForm({
    searchText: '',
  });
  const { searchText } = formValues;

  const handleSearch = (event) => {
    event.preventDefault();
    getAllCertificatesStudentsService(1, searchText).then((resp) => {
      console.log(resp)
      if (resp.data.success) {
        localStorage.setItem('certificates', JSON.stringify(resp.data.data.data))
        setCertificates(resp.data.data.data);
        setPages(resp.data.data.paginacion);

      } else {
        if (resp.data.code == 401) {
          swal({
            title: "Alerta!!!",
            text: `${resp.data.data.message}`,
            icon: "warning",
            dangerMode: true,
          }).then(function () {
            window.location = "/bienvenido";
          });
        }
      }
    }).catch((error) => {
      swal({
        title: "Error",
        text: `Sucedió un error: ${error}`,
        icon: "error",
        dangerMode: true,
      });
    });
  }

  let classBg = "bg-[#fff]";
  useEffect(() => {
    setTimeout(() => {
      getAllCertificatesStudentsService(1, '').then((resp) => {
        console.log(resp.data.data.data)
        if (resp.data.success) {
          localStorage.setItem('certificates', JSON.stringify(resp.data.data.data))

          setCertificates(resp.data.data.data);
          setPages(resp.data.data.paginacion);
        } else {
          if (resp.data.code == 401) {
            swal({
              title: "Alerta!!!",
              text: `${resp.data.data.message}`,
              icon: "warning",
              dangerMode: true,
            }).then(function () {
              window.location = "/bienvenido";
            });
          }
        }
      }).catch((error) => {
        swal({
          title: "Error",
          text: `Sucedió un error: ${error}`,
          icon: "error",
          dangerMode: true,
        });
      });
    }, 1000);
  }, []);

  const handleBackPage = (pageBack) => {
    getAllCertificatesStudentsService(pageBack - 1, searchText).then((resp) => {
      if (resp.data.success) {
        localStorage.setItem('certificates', JSON.stringify(resp.data.data.data))

        setCertificates(resp.data.data.data);
        setPages(resp.data.data.paginacion);
      } else {
        if (resp.data.code == 401) {
          swal({
            title: "Alerta!!!",
            text: `${resp.data.data.message}`,
            icon: "warning",
            dangerMode: true,
          }).then(function () {
            window.location = "/bienvenido";
          });
        }
      }
    }).catch((error) => {
      swal({
        title: "Error",
        text: `Sucedió un error: ${error}`,
        icon: "error",
        dangerMode: true,
      });
    });
  }
  const handleNextPage = (page) => {
    getAllCertificatesStudentsService(page + 1, searchText).then((resp) => {
      if (resp.data.success) {
        localStorage.setItem('certificates', JSON.stringify(resp.data.data.data))

        setCertificates(resp.data.data.data);
        setPages(resp.data.data.paginacion);
      } else {
        if (resp.data.code == 401) {
          swal({
            title: "Alerta!!!",
            text: `${resp.data.data.message}`,
            icon: "warning",
            dangerMode: true,
          }).then(function () {
            window.location = "/bienvenido";
          });
        }
      }
    }).catch((error) => {
      swal({
        title: "Error",
        text: `Sucedió un error: ${error}`,
        icon: "error",
        dangerMode: true,
      });
    });
  }

  const handleFirstPage = (page) => {
    getAllCertificatesStudentsService(1, searchText).then((resp) => {
      if (resp.data.success) {
        localStorage.setItem('certificates', JSON.stringify(resp.data.data.data))

        setCertificates(resp.data.data.data);
        setPages(resp.data.data.paginacion);
      } else {
        if (resp.data.code == 401) {
          swal({
            title: "Alerta!!!",
            text: `${resp.data.data.message}`,
            icon: "warning",
            dangerMode: true,
          }).then(function () {
            window.location = "/bienvenido";
          });
        }
      }
    }).catch((error) => {
      swal({
        title: "Error",
        text: `Sucedió un error: ${error}`,
        icon: "error",
        dangerMode: true,
      });
    });
  }

  const handleLastPage = (page) => {
    getAllCertificatesStudentsService(page, searchText).then((resp) => {
      if (resp.data.success) {
        localStorage.setItem('certificates', JSON.stringify(resp.data.data.data))

        setCertificates(resp.data.data.data);
        setPages(resp.data.data.paginacion);
      } else {
        if (resp.data.code == 401) {
          swal({
            title: "Alerta!!!",
            text: `${resp.data.data.message}`,
            icon: "warning",
            dangerMode: true,
          }).then(function () {
            window.location = "/bienvenido";
          });
        }
      }
    }).catch((error) => {
      swal({
        title: "Error",
        text: `Sucedió un error: ${error}`,
        icon: "error",
        dangerMode: true,
      });
    });
  }


  return (
    <div className="flex flex-col px-5 mt-5">
      {
        hasListarEstudaintesPermission && (
          <div className="overflow-x-auto">
            <div className="p-5 inline-block min-w-full bg-[#67b5dd] rounded-[12px] mb-5 ">

              <div className="p-3">
                <div className="buscador sincronizar">
                  <form onSubmit={handleSearch}>
                    <div className="flex">
                      <div className="w-full">
                        <input
                          type="text"
                          className="rounded-[12px] form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none mr-3"
                          id="exampleFormControlInput1"
                          placeholder="Buscar"
                          name="searchText"
                          autoComplete='off'
                          value={searchText}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="pl-5">
                        <button
                          type="submit"
                          className=" py-2.5 bg-[#93b33a] text-white Metropolis-Bold text-xs leading-tight uppercase rounded-md shadow-md hover:bg-[#93b33a] hover:shadow-lg focus:bg-[#93b33a] focus:shadow-lg focus:outline-none focus:ring-0 active:bg-[#93b33a] active:shadow-lg transition  pl-3 pr-3 duration-150 ease-in-out"
                        >
                          Buscar
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div className='grid justify-items-center bg-[#243F59] bg-opacity-30 rounded-t-xl ml-3 mr-3'>
                <span>
                  {page.onFirstPage !== true ?
                    <button onClick={(event) => handleFirstPage(page.currentPage)} className="bg-[#243F59] rounded px-3 py-2 text-base text-white Metropolis-Bold mb-3 mt-3 ml-1 mr-1">◀◀</button>
                    :
                    <button disabled onClick={(event) => handleFirstPage(page.currentPage)} className="bg-[#243F59] rounded px-3 py-2 text-base text-white Metropolis-Bold mb-3 mt-3 ml-1 mr-1 cursor-not-allowed opacity-50">◀◀</button>
                  }

                  {page.onFirstPage !== true ?
                    <button onClick={(event) => handleBackPage(page.currentPage)} className="bg-[#243F59] rounded px-4 py-2 text-base text-white Metropolis-Bold mb-3 mt-3 ml-1 mr-1">◀</button>
                    :
                    <button disabled onClick={(event) => handleBackPage(page.currentPage)} className="bg-[#243F59] rounded px-4 py-2 text-base text-white Metropolis-Bold mb-3 mt-3 ml-1 mr-1 cursor-not-allowed opacity-50">◀</button>
                  }

                  <span className="bg-white rounded px-4 py-2 text-base text-[#243F59] Metropolis mt-5 ml-1 mr-1">Página <b>{page.currentPage}</b> de <b>{page.lastPage}</b></span>

                  {page.hasMorePages === true ?
                    <button onClick={(event) => handleNextPage(page.currentPage)} className="bg-[#243F59] rounded px-4 py-2 text-base text-white Metropolis-Bold mb-3 mt-3 ml-1 mr-1">▶</button>
                    :
                    <button disabled onClick={(event) => handleNextPage(page.currentPage)} className="bg-[#243F59] rounded px-4 py-2 text-base text-white Metropolis-Bold mb-3 mt-3 ml-1 mr-1 cursor-not-allowed opacity-50">▶</button>
                  }

                  {page.hasMorePages !== false ?
                    <button onClick={(event) => handleLastPage(page.lastPage)} className="bg-[#243F59] rounded px-3 py-2 text-base text-white Metropolis-Bold mb-3 mt-3 ml-1 mr-1">▶▶</button>
                    :
                    <button disabled onClick={(event) => handleLastPage(page.lastPage)} className="bg-[#243F59] rounded px-3 py-2 text-base text-white Metropolis-Bold mb-3 mt-3 ml-1 mr-1 cursor-not-allowed opacity-50">▶▶</button>
                  }

                  <span className="bg-white rounded px-4 py-2 text-base text-[#243F59] Metropolis mt-5 ml-1 mr-1"><b>{page.total}</b> Registros</span>
                </span>
              </div>
              <div className="overflow-hidden">

                <table className="min-w-full border-x border-[#243F59] text-center rounded-[12px] overflow-hidden">
                  <thead className="border-x bg-[#243f59] rounded-[12px]">
                    <tr>
                      <th className="text-sm text-white Metropolis-Bold px-4 py-4 text-left border-r">
                        Código Curso
                      </th>
                      <th className="text-sm text-white Metropolis-Bold px-4 py-4 text-left border-r">
                        Documento
                      </th>
                      <th className="text-sm text-white Metropolis-Bold px-4 py-4 text-left border-r">
                        Estudiante
                      </th>
                    </tr>
                  </thead>
                  <tbody className="border-b bg-[#fff]">
                    {certificates.map((certificado, index) => {
                      if (index % 2 === 0) {
                        classBg = "bg-[#ececec]";
                      } else {
                        classBg = "bg-[#fff]";
                      }
                      return (
                        <tr
                          key={certificado.certificadoId}
                          className={`border-b ${classBg}`}
                        >
                          <td className="text-sm text-gray-900 Metropolis-Light px-4 py-4 border-r">
                            {certificado.codigoCurso}
                          </td>
                          <td className="text-sm text-gray-900 Metropolis-Light px-4 py-4 border-r">
                            {certificado.documento}
                          </td>
                          <td className="text-sm text-gray-900 Metropolis-Light px-4 py-4 border-r">
                            {certificado.nombres} {certificado.apellidos}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              <div className='grid justify-items-center bg-[#243F59] bg-opacity-30 rounded-b-xl ml-3 mr-3'>
                <span>
                  {page.onFirstPage !== true ?
                    <button onClick={(event) => handleFirstPage(page.currentPage)} className="bg-[#243F59] rounded px-3 py-2 text-base text-white Metropolis-Bold mb-3 mt-3 ml-1 mr-1">◀◀</button>
                    :
                    <button disabled onClick={(event) => handleFirstPage(page.currentPage)} className="bg-[#243F59] rounded px-3 py-2 text-base text-white Metropolis-Bold mb-3 mt-3 ml-1 mr-1 cursor-not-allowed opacity-50">◀◀</button>
                  }

                  {page.onFirstPage !== true ?
                    <button onClick={(event) => handleBackPage(page.currentPage)} className="bg-[#243F59] rounded px-4 py-2 text-base text-white Metropolis-Bold mb-3 mt-3 ml-1 mr-1">◀</button>
                    :
                    <button disabled onClick={(event) => handleBackPage(page.currentPage)} className="bg-[#243F59] rounded px-4 py-2 text-base text-white Metropolis-Bold mb-3 mt-3 ml-1 mr-1 cursor-not-allowed opacity-50">◀</button>
                  }

                  <span className="bg-white rounded px-4 py-2 text-base text-[#243F59] Metropolis mt-5 ml-1 mr-1">Página <b>{page.currentPage}</b> de <b>{page.lastPage}</b></span>

                  {page.hasMorePages === true ?
                    <button onClick={(event) => handleNextPage(page.currentPage)} className="bg-[#243F59] rounded px-4 py-2 text-base text-white Metropolis-Bold mb-3 mt-3 ml-1 mr-1">▶</button>
                    :
                    <button disabled onClick={(event) => handleNextPage(page.currentPage)} className="bg-[#243F59] rounded px-4 py-2 text-base text-white Metropolis-Bold mb-3 mt-3 ml-1 mr-1 cursor-not-allowed opacity-50">▶</button>
                  }

                  {page.hasMorePages !== false ?
                    <button onClick={(event) => handleLastPage(page.lastPage)} className="bg-[#243F59] rounded px-3 py-2 text-base text-white Metropolis-Bold mb-3 mt-3 ml-1 mr-1">▶▶</button>
                    :
                    <button disabled onClick={(event) => handleLastPage(page.lastPage)} className="bg-[#243F59] rounded px-3 py-2 text-base text-white Metropolis-Bold mb-3 mt-3 ml-1 mr-1 cursor-not-allowed opacity-50">▶▶</button>
                  }

                  <span className="bg-white rounded px-4 py-2 text-base text-[#243F59] Metropolis mt-5 ml-1 mr-1"><b>{page.total}</b> Registros</span>
                </span>
              </div>

            </div>
          </div>
        )
      }
    </div>
  );
};
